

import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import CustomSelect from "components/Common/custom-select";
import CustomDatePicker from "common/CustomDatePicker";
import TableContainer from "components/Common/TableContainer";
import { useFormik } from "formik";
import * as Yup from "yup";

const departmentOptions = [
  { label: "QUALITY CONTROL", value: "QUALITY CONTROL" },
  { label: "CUTTING", value: "CUTTING" },
  { label: "Admin", value: "Admin" },
  { label: "STORE", value: "STORE" },
  { label: "IED", value: "IED" },
  { label: "PACKING", value: "PACKING" },
  { label: "PRODUCTION", value: "PRODUCTION" },
  { label: "QUALITY", value: "QUALITY" },
  { label: "ANCILLARY", value: "ANCILLARY" },
  { label: "EMBROIDERY", value: "EMBROIDERY" },
];

const categoryOptions = [
  { label: "Admin", value: "Admin" },
  { label: "Staff", value: "Staff" },
  { label: "Foreman", value: "Foreman" },
];

const AttendanceReportDayWiseAbstract = () => {
  const formik = useFormik({
    initialValues: {
      department: "",
      category: "",
      code: "",
      name: "",
      date: "",
    },
    onSubmit: (values) => {
      console.log("Form Values:", values);
    },
  });

  const data = [
    { emp: 1, name: "ARUN", date: "26.05.25", in: "5:53AM", out: "2:09PM", worked: "08:16:00", break: "00:00:00" },
    { emp: 10, name: "GOWRI", date: "26.05.25", in: "5:52AM", out: "2:06PM", worked: "08:14:00", break: "00:00:00" },
    { emp: 11111, name: "VARMAN", date: "26.05.25", in: "8:32AM", out: "5:38PM", worked: "09:06:00", break: "00:00:00" },
    { emp: 12, name: "RAMACHANDRAN", date: "26.05.25", in: "7:51AM", out: "4:54PM", worked: "09:03:00", break: "00:00:00" },
    { emp: 1212, name: "DAKSHIN", date: "26.05.25", in: "5:51AM", out: "1:54PM", worked: "08:03:00", break: "00:00:00" },
    { emp: 1212, name: "DAKSHIN", date: "26.05.25", in: "6:04AM", out: "2:05PM", worked: "08:01:00", break: "00:00:00" },
    { emp: 13, name: "SUSHMITHA", date: "26.05.25", in: "6:06AM", out: "2:01PM", worked: "07:55:00", break: "00:00:00" },
    { emp: 14, name: "TANYA", date: "26.05.25", in: "8:07AM", out: "5:01PM", worked: "08:54:00", break: "00:00:00" },
    { emp: 1406, name: "VISHNU", date: "26.05.25", in: "6:04AM", out: "2:10PM", worked: "08:06:00", break: "00:00:00" },
    // More rows as needed
  ];

  const columns = [
    { Header: "S No", Cell: ({ row }) => data.length - row.index, className: "serial-no text-center", },
    { Header: "Emp", accessor: "emp" },
    { Header: "Name", accessor: "name" },
    { Header: "Date", accessor: "date" },
    { Header: "In", accessor: "in" },
    { Header: "Out", accessor: "out" },
    { Header: "Worked hrs", accessor: "worked" },
    { Header: "Break hrs", accessor: "break" },
  ];

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Attendance" breadcrumbItem="Day Wise Abstract" />
        <Card>
          <CardBody>
            <form onSubmit={formik.handleSubmit}>
              <Row className="gy-3">
                <Col md={4}>
                  <Label>Department</Label>
                  <CustomSelect
                    name="department"
                    value={formik.values.department}
                    onChange={(val) => formik.setFieldValue("department", val)}
                    options={departmentOptions}
                    placeholder="--Select--"
                  />
                </Col>

                <Col md={4}>
                  <Label>Category</Label>
                  <CustomSelect
                    name="category"
                    value={formik.values.category}
                    onChange={(val) => formik.setFieldValue("category", val)}
                    options={categoryOptions}
                    placeholder="--Select--"
                  />
                </Col>

                <Col md={4}>
                  <Label>Code</Label>
                  <input
                    type="text"
                    name="code"
                    value={formik.values.code}
                    onChange={formik.handleChange}
                    className="form-control"
                  />
                </Col>

                <Col md={4}>
                  <Label>Name</Label>
                  <input
                    type="text"
                    name="name"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    className="form-control"
                  />
                </Col>

                <Col md={4}>
                  <Label>Date </Label>
                  <CustomDatePicker
                    name="date"
                    value={formik.values.date}
                    onChange={(val) => formik.setFieldValue("date", val)}
                    onBlur={() => formik.setFieldTouched("date", true)}
                  />
                </Col>

                <Col md={4} className="d-flex align-items-end justify-content-end">
                  <Button type="submit" className="btn button-search">
                    <i className="fas fa-search me-1" /> Search
                  </Button>
                </Col>
              </Row>
            </form>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <TableContainer
              columns={columns}
              data={data}
              isGlobalFilter={true}
              customPageSize={10}
              tableSorter={true}
            />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default AttendanceReportDayWiseAbstract;
